import { Injectable } from "@angular/core";
import { Events } from "ionic-angular";
import { EncryptStorageEvent, MessengerModel } from "../..";
var MessengerProvider = /** @class */ (function () {
    function MessengerProvider(_model, _events) {
        this._model = _model;
        this._events = _events;
        this._ready = false;
        this.bind();
    }
    MessengerProvider.prototype.bind = function () {
        var _this = this;
        this._events.subscribe(EncryptStorageEvent.LOCAL_STORAGE_CREATED, function () {
            _this._model.clear(false, true);
        });
    };
    Object.defineProperty(MessengerProvider.prototype, "model", {
        get: function () {
            return this._model;
        },
        enumerable: true,
        configurable: true
    });
    MessengerProvider.prototype.load = function () {
        this._model.loadWelcomeVisited();
        this._ready = true;
        this._events.publish(MessengerProviderEvent.READY);
    };
    Object.defineProperty(MessengerProvider.prototype, "ready", {
        get: function () {
            return this._ready;
        },
        enumerable: true,
        configurable: true
    });
    MessengerProvider.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    MessengerProvider.ctorParameters = function () { return [
        { type: MessengerModel, },
        { type: Events, },
    ]; };
    return MessengerProvider;
}());
export { MessengerProvider };
export var MessengerProviderEvent;
(function (MessengerProviderEvent) {
    MessengerProviderEvent["READY"] = "messenger-provider:ready";
})(MessengerProviderEvent || (MessengerProviderEvent = {}));
//# sourceMappingURL=messenger-provider.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/providers/messenger/messenger-provider.js
// module id = 166
// module chunks = 14